import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

// ✅ Your Beehiiv RSS Feed
const RSS_FEED = "https://rss.beehiiv.com/feeds/STfvDlt461.xml";

function FurNews() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

useEffect(() => {
  async function fetchPosts() {
    try {
      const res = await fetch(
        `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(
          RSS_FEED
        )}&_=${new Date().getTime()}`
      );

      const data = await res.json();

      if (data.items) {
        setPosts(data.items);
      } else {
        setError(true);
      }
    } catch (err) {
      setError(true);
    } finally {
      setLoading(false);
    }
  }

  fetchPosts();
}, []);

  if (loading)
    return (
      <section>
        <Navbar />
        <div style={styles.loading}>
          <i className="fa fa-paw" style={styles.loadingPaw}></i>
          <p>Loading FurNews issues...</p>
        </div>
        <Footer />
      </section>
    );

  return (
    <section>
      <Helmet>
        <title>FurNews – Past Issues – Furbabies.AI</title>
        <meta
          name="description"
          content="Browse all past FurNews issues. Weekly pet health tips, nutrition guides, and AI-powered care advice for pet lovers."
        />
      </Helmet>

      <Navbar />

      {/* HERO */}
      <div style={styles.hero}>
        <motion.h1
          style={styles.heroTitle}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          FurNews Archive
        </motion.h1>
        <motion.p
          style={styles.heroSubtitle}
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.7 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          Every issue of our weekly pet care newsletter
        </motion.p>
      </div>

      {/* ISSUES GRID */}
      <div style={styles.container}>
        {error && (
          <div style={styles.errorBox}>
            <p style={styles.errorTitle}>Issues loading soon</p>
          </div>
        )}

        {!error && posts.length === 0 && (
          <div style={styles.empty}>
            <p>No issues yet — the first FurNews is coming soon!</p>
            <Link to="/newsletter" style={styles.subscribeInline}>
              Subscribe to get notified →
            </Link>
          </div>
        )}

        {posts.length > 0 && (
          <div style={styles.grid}>
            {posts.map((post, i) => (
              <motion.a
                key={i}
                href={post.link}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.card}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
              >
                <div style={styles.issueBadge}>
                  Issue #{posts.length - i}
                </div>

                {post.thumbnail ? (
                  <img
                    src={post.thumbnail}
                    alt={post.title}
                    style={styles.cardImage}
                    loading="lazy"
                  />
                ) : (
                  <div style={styles.cardImagePlaceholder}></div>
                )}

                <div style={styles.cardBody}>
                  <p style={styles.date}>
                    {new Date(post.pubDate).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })}
                  </p>

                  <h2 style={styles.cardTitle}>{post.title}</h2>

                  <p style={styles.cardExcerpt}>
                    {post.description.replace(/<[^>]+>/g, '').slice(0, 140)}...
                  </p>

                  <span style={styles.readMore}>Read this issue →</span>
                </div>
              </motion.a>
            ))}
          </div>
        )}
      </div>
      
      {/* BOTTOM CTA */}
      <section style={styles.ctaSection}>
        <motion.h2
          style={styles.ctaTitle}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          Never Miss a FurNews Issue
        </motion.h2>
        <p style={styles.ctaText}>
          Join thousands of pet lovers getting weekly health tips and nutrition guides.
        </p>
        <Link to="/newsletter" style={styles.ctaButton}>
          Subscribe Free
        </Link>
      </section>


      

      <Footer />
    </section>
  );
}

// const styles = {
//   loading: { textAlign: 'center', padding: '120px 20px' },
//   loadingPaw: { fontSize: '3rem', marginBottom: '16px' },

//   hero: {
//     background: '#BDA697',
//     textAlign: 'center',
//     padding: '80px 20px',
//     marginTop: '11rem',
//   },

//   heroTitle: {
//     fontFamily: "'Poltawski Nowy', serif",
//     fontSize: 'clamp(3.5rem, 10vw, 6rem)',
//     fontWeight: 'bold',
//     color: 'white',
//   },

//   heroSubtitle: {
//     fontFamily: "'Poppins', sans-serif",
//     fontSize: '1.1rem',
//     color: '#222',
//     opacity: 0.7,
//   },

//   container: {
//     maxWidth: '1100px',
//     margin: '0 auto',
//     padding: '60px 20px',
//   },

//   grid: {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
//     gap: '32px',
//   },

//   card: {
//     display: 'block',
//     textDecoration: 'none',
//     borderRadius: '16px',
//     overflow: 'hidden',
//     background: '#fff',
//     boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
//   },

//   issueBadge: {
//     padding: '12px 20px',
//     background: '#f4ede7',
//     fontWeight: '700',
//     color: '#967d6c',
//   },

//   cardImage: {
//     width: '100%',
//     height: '200px',
//     objectFit: 'cover',
//   },

//   cardImagePlaceholder: {
//     width: '100%',
//     height: '200px',
//     background: '#e8e1da',
//   },

//   cardBody: { padding: '24px' },

//   date: { fontSize: '0.8rem', color: '#999', marginBottom: '10px' },

//   cardTitle: {
//     fontFamily: "'Poltawski Nowy', serif",
//     fontSize: '1.3rem',
//     fontWeight: 'bold',
//     marginBottom: '10px',
//   },

//   cardExcerpt: {
//     fontSize: '0.9rem',
//     opacity: 0.6,
//     marginBottom: '16px',
//   },

//   readMore: {
//     fontWeight: '700',
//     color: '#967d6c',
//   },

//   errorBox: {
//     textAlign: 'center',
//     padding: '60px',
//     background: '#f4ede7',
//     borderRadius: '16px',
//   },

//   errorTitle: {
//     fontSize: '1.4rem',
//     fontWeight: 'bold',
//   },

//   errorText: {
//     fontSize: '0.95rem',
//     opacity: 0.7,
//   },

//   empty: {
//     textAlign: 'center',
//     padding: '80px',
//   },

//   subscribeInline: {
//     color: '#967d6c',
//     fontWeight: '700',
//     textDecoration: 'none',
//   },
// };


const styles = {
  loading: { textAlign: 'center', padding: '120px 20px', fontFamily: "'Poppins', sans-serif", fontSize: '1.2rem', color: '#967d6c', display: 'flex', flexDirection: 'column', alignItems: 'center' },
  loadingPaw: { fontSize: '3rem', color: '#bda697', marginBottom: '16px', display: 'block' },

 hero: { background: '#BDA697', textAlign: 'center', padding: '80px 20px 80px',marginTop: '11rem', position: 'relative', overflow: 'hidden' },
  heroTitle: { fontFamily: "'Poltawski Nowy', serif", fontSize: 'clamp(3.5rem, 10vw, 6rem)', fontWeight: 'bold', color: 'white', marginBottom: '16px', lineHeight: '1.1' },
  heroMeta: { fontFamily: "'Poppins', sans-serif", fontSize: '0.95rem', color: '#222222', opacity: 0.5, marginTop: '12px' },
  heroSubtitle: { fontFamily: "'Poppins', sans-serif", fontSize: '1.1rem', color: '#222222', opacity: 0.7, marginBottom: '32px' },
  subscribeBtn: { display: 'inline-block', background: '#967d6c', color: 'white', padding: '14px 40px', borderRadius: '9999px', fontFamily: "'Poppins', sans-serif", fontWeight: 'bold', fontSize: '1rem', textDecoration: 'none' },

  container: { maxWidth: '1100px', margin: '0 auto', padding: '60px 20px' },

  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '32px' },

  card: { display: 'block', textDecoration: 'none', color: 'inherit', borderRadius: '16px', overflow: 'hidden', background: '#ffffff', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', transition: 'transform 0.2s ease, box-shadow 0.2s ease' },
  issueBadge: { display: 'flex', alignItems: 'center', padding: '12px 20px', background: '#f4ede7', fontFamily: "'Poppins', sans-serif", fontSize: '0.8rem', fontWeight: '700', color: '#967d6c', textTransform: 'uppercase', letterSpacing: '0.5px' },
  cardImage: { width: '100%', height: '200px', objectFit: 'cover', display: 'block' },
  cardImagePlaceholder: { width: '100%', height: '200px', background: '#e8e1da', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  cardBody: { padding: '24px' },
  date: { fontFamily: "'Poppins', sans-serif", fontSize: '0.8rem', color: '#999', marginBottom: '10px' },
  cardTitle: { fontFamily: "'Poltawski Nowy', serif", fontSize: '1.3rem', fontWeight: 'bold', color: '#222222', marginBottom: '10px', lineHeight: '1.4' },
  cardExcerpt: { fontFamily: "'Poppins', sans-serif", fontSize: '0.9rem', color: '#222222', opacity: 0.6, lineHeight: '1.7', marginBottom: '16px' },
  readMore: { fontFamily: "'Poppins', sans-serif", fontSize: '0.9rem', color: '#967d6c', fontWeight: '700' },

  subscribeNudge: { textAlign: 'center', marginTop: '48px', fontFamily: "'Poppins', sans-serif", fontSize: '1rem', color: '#555' },
  subscribeNudgeLink: { color: '#967d6c', fontWeight: '700', textDecoration: 'none' },

  errorBox: { textAlign: 'center', padding: '60px', background: '#f4ede7', borderRadius: '16px', maxWidth: '500px', margin: '0 auto' },
  errorTitle: { fontFamily: "'Poltawski Nowy', serif", fontSize: '1.4rem', fontWeight: 'bold', color: '#222222', marginBottom: '12px' },
  errorText: { fontFamily: "'Poppins', sans-serif", fontSize: '0.95rem', color: '#555', lineHeight: '1.7' },

  empty: { textAlign: 'center', padding: '80px', display: 'flex', flexDirection: 'column', alignItems: 'center', fontFamily: "'Poppins', sans-serif", color: '#aaa' },
  subscribeInline: { marginTop: '16px', color: '#967d6c', fontWeight: '700', textDecoration: 'none' },

  ctaSection: { background: '#e8e1da', textAlign: 'center', padding: '80px 20px', marginBottom:"4rem" },
  ctaTitle: { fontFamily: "'Poltawski Nowy', serif", fontSize: 'clamp(2rem, 5vw, 3.5rem)', fontWeight: 'bold', color: '#222222', marginBottom: '16px' },
  ctaText: { fontFamily: "'Poppins', sans-serif", fontSize: '1.1rem', color: '#222222', opacity: 0.6, marginBottom: '36px' },
  ctaButton: { display: 'inline-block', background: '#967d6c', color: 'white', padding: '16px 48px', borderRadius: '9999px', fontFamily: "'Poppins', sans-serif", fontWeight: 'bold', fontSize: '1.1rem', textDecoration: 'none' },
};

export default FurNews;